import { useQuery } from "@tanstack/react-query";
import { GeocodeResponse, geocodeKeys } from "~/features/geocodes";

const HERE_ENDPOINT = "https://geocoder.ls.hereapi.com/6.2/geocode.json?";

export function useGeocodes(locationid: string) {
  const options = {
    locationid,
    country: "CAN,USA",
    apiKey: import.meta.env.VITE_HERE_API_KEY as string,
  };

  const fetchGeocodes = (): Promise<GeocodeResponse> =>
    fetch(HERE_ENDPOINT + new URLSearchParams(options))
      .then((response) => response.json())
      .then((response) => response.Response.View[0].Result[0]);

  return useQuery(geocodeKeys.list(options), fetchGeocodes, {
    enabled: !!locationid,
  });
}
